import React from 'react';
import { theme } from '../../ui/theme';

/**
 * 首页专用：暗色“玻璃卡”容器
 * - 统一边框与背景层，避免 HomeLanding 重复 className
 */
export default function HomeGlassCard({ children, className = '' }) {
  return (
    <div
      className={[
        theme.surfaces.glassCard,
        'p-4',
        className
      ].join(' ')}
    >
      {children}
    </div>
  );
}

